export const portfolioTabsTitle = [
    {
        "id": 1,
        "title": "All",
    },
    {
        "id": 2,
        "title": "Web design",
    },
    {
        "id": 3,
        "title": "Graphic design",
    },
    {
        "id": 4,
        "title": "Landing pages",
    },
    {
        "id": 5,
        "title": "Wordpress",
    }

];




// WEBPACK FOOTER //
// ./src/data/portfolioTabsTitle.js